import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const sendUserData = serviceBase({
  request: (info) => axiosClient.post(`subscription`, info),
});

export default sendUserData;
